import { render } from "./Index.vue?vue&type=template&id=62052708"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sanzharzhubatkan/Sanzhar/Work/EduCenter/local-projects/educenter-update/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__